/**
 * Break-glass allowlist for Avery autonomy KILL SWITCHES — ops UI mirror.
 *
 * This is presentation only: it hides the nav item / bounces the route and
 * disables the toggles for anyone who isn't allowed. The REAL enforcement is
 * server-side in both services (parkify-pay/api/src/auth/kill-switch-admins.ts
 * + parkify-cs/app/services/kill_switch_admins.py) — those return 403, so a
 * hand-crafted request can't flip a switch even with the UI bypassed.
 *
 * Keep this list identical to the two server mirrors. To change who's allowed,
 * edit all three and redeploy.
 */
export const KILL_SWITCH_ADMINS: readonly string[] = [
  'apatterson@parkify.com',
  'ataylor@parkify.com',
]

export function isKillSwitchAdmin(email: string | null | undefined): boolean {
  if (!email) return false
  return KILL_SWITCH_ADMINS.includes(email.trim().toLowerCase())
}
